import { render, staticRenderFns } from "./FigmaFolderLayer.vue?vue&type=template&id=6e248682&scoped=true"
import script from "./FigmaFolderLayer.vue?vue&type=script&lang=js"
export * from "./FigmaFolderLayer.vue?vue&type=script&lang=js"
import style0 from "./FigmaFolderLayer.vue?vue&type=style&index=0&id=6e248682&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e248682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e248682')) {
      api.createRecord('6e248682', component.options)
    } else {
      api.reload('6e248682', component.options)
    }
    module.hot.accept("./FigmaFolderLayer.vue?vue&type=template&id=6e248682&scoped=true", function () {
      api.rerender('6e248682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/layers/FigmaFolderLayer.vue"
export default component.exports